import { render, staticRenderFns } from "./QuizTeacherDashboard.vue?vue&type=template&id=c17da2fe&"
import script from "./QuizTeacherDashboard.vue?vue&type=script&lang=js&"
export * from "./QuizTeacherDashboard.vue?vue&type=script&lang=js&"
import style0 from "./QuizTeacherDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports